export default "__VITE_ASSET__CopBilGW__"